<template>
  <div class="notarization-progress">
    <!-- <div class="content-top clearfix">当前位置：
      <span @click="goDataList">公证服务-数据列表</span>-公证进度</div> -->
    <div class="content-main">
      <div class="progress-current">
        <div class="step-box">
          <div class="step-step1 step-subbox" v-if="stepControl.step1Tit">
            <img src="@assets/images/judicial/step1.png"  />
            <div class="step-line"></div>
          </div>
          <div class="step-step2 step-subbox" v-if="stepControl.step2Tit">
            <img src="@assets/images/judicial/step2.png" style="right:-45px;" />
            <div class="step-line"></div>
          </div>
          <div class="step-step3 step-subbox" v-if="stepControl.step3Tit">
            <img src="@assets/images/judicial/step3.png" style="right:-29px;"  />
            <div class="step-line"></div>
          </div>
          <!-- <div class="step-step4 step-subbox" v-if="stepControl.step4Tit">
            <img src="@assets/images/judicial/step4.png" />
            <div class="step-line"></div>
          </div> -->
          <div class="step-step5 step-subbox" v-if="stepControl.step5Tit">
            <img src="@assets/images/judicial/step4.png" style="right:-67px;" />
            <div class="step-line"></div>
          </div>
        </div>
        <ul class="progress-current-info">
          <li :class="{'progress-current-info-li':stepControl.step1Tit}">填写信息</li>
          <li :class="{'progress-current-info-li':stepControl.step2Tit}">签署文件</li>
          <li :class="{'progress-current-info-li':stepControl.step3Tit}">信息审核</li>
          <!-- <li :class="{'progress-current-info-li':stepControl.step4Tit}">支付费用</li> -->
          <li :class="{'progress-current-info-li':stepControl.step5Tit}">预约取证</li>
        </ul>
      </div>
      <div class="progress-con">
        <!-- 申请信息 -->
        <div class="progress-con1" v-if="stepControl.step1">
          <div class="pro-con-details">
            <div class="details-title">申请信息</div>
            <div class="apply-contact-infos">
              <p>
                <label>申请公证名称：</label>
                <span>{{notarizationInfo.notarizationName}}</span>
              </p>
              <p>
                <label>包含文件数量：</label>
                <span>{{notarizationInfo.evidenceCount}}</span>
              </p>
              <p>
                <label>文件总大小：</label>
                <span>{{filterType(notarizationInfo.packageSize)}}</span>
              </p>
              <p>
                <label>公&nbsp;证&nbsp;处：</label>
                <span>{{notarizationInfo.notarial}}</span>
              </p>
              <p>
                <label>公证处地址：</label>
                <span>{{notarizationInfo.location}}</span>
              </p>
              <p>
                <label>公证员：</label>
                <span>{{notarizationInfo.internalNotaryName}}</span>
              </p>
               <p>
                <label>领取人：</label>
                <span>{{notarizationInfo.receiptorTypeName}}</span>
              </p>
              <!-- 
              <p>
                <label>公证书领取：</label>
                <span>{{notarizationInfo.receiptorTypeName}}</span>
              </p> -->
              <p>
                <label>备注：</label>
                <span style="display: inline-block; width: 600px;word-wrap: break-word;line-height: 30px;vertical-align: top;">{{notarizationInfo.remarks}}</span>
              </p>
            </div>
          </div>
          <div class="pro-con-details" style="margin-top: 30px;">
            <div class="details-title">申请人信息</div>
            <div class="apply-contact-infos">
                
                <template v-if="result.realNameType == 2">
                  <p>
                    <label>机构名称：</label>
                    <span>{{result.realName}}</span>
                  </p>
                  <!-- <p v-if="result.realNameType == 2">
                    <label>统一社会信用代码：</label>
                    <span>{{notarizationInfo.code}}</span>
                  </p> -->
                  <p>
                    <label>地址：</label>
                    <!-- <input type="text" placeholder="请输入地址" v-model="notarization.userAddress" @blur="checkUserAddress" /> -->
                    <span>{{result.provinceName+''+result.areaName+''+result.cityName+''+result.enterpriseAddress}}</span>
                  </p>
                  <p>
                    <label>法人姓名：</label>
                    <input type="text" placeholder="请输入法人姓名" v-model="notarization.legalPerson" @blur="checklegalPerson" />
                    <span class="errorTips" v-model="errorTips.legalPerson">{{errorTips.legalPerson}}</span>
                  </p>
                  <p>
                    <label>法人身份证号码：</label>
                    <input type="text" placeholder="请输入法人身份证号码" v-model="notarization.legalPersonIdCardNumber" @blur="checklegalPersonIdCardNumber" />
                    <span class="errorTips" v-model="errorTips.legalPersonIdCardNumber">{{errorTips.legalPersonIdCardNumber}}</span>
                  </p>
                  <p>
                    <label>法人手机号码：</label>
                    <input type="text" placeholder="请输入法人手机号码" v-model="notarization.legalPersonTel" @blur="checklegalPersonTel" />
                    <span class="errorTips" v-model="errorTips.legalPersonTel">{{errorTips.legalPersonTel}}</span>
                  </p>
                  <p>
                    <label>职务：</label>
                    <input type="text" placeholder="请输入法人职务" v-model="notarization.legalPersonPost" @blur="checklegalPersonPost" />
                    <span class="errorTips" v-model="errorTips.legalPersonPost">{{errorTips.legalPersonPost}}</span>
                  </p>
                </template>
                <p >
                  <label>申请人姓名：</label>
                  <!-- <span>{{notarizationInfo.applier}}</span> -->
                  <span>{{notarizationInfo.realname}}</span>
                </p>
                <p>
                  <label>申请人身份证号码：</label>
                  <!-- <span v-if="result.realNameType == 1">{{notarizationInfo.userIdCard}}</span> -->
                  <span >{{notarizationInfo.idcardNumber}}</span>
                </p>
                <p >
                  <label>申请人手机号码：</label>
                  <input v-show="!notarization.applyMobile" type="text" placeholder="请输入手机号" v-model="newApplyMobile" @blur="checkReceiptorMobiles" />
                  <span v-show="notarization.applyMobile">{{notarization.applyMobile}}</span>
                  <span class="errorTips" v-model="errorTips.newApplyMobile">{{errorTips.newApplyMobile}}</span>
                </p>
                 <p >
                  <label>申请人邮箱：</label>
                  <input v-show="!notarization.applyMail" type="text" placeholder="请输入邮箱" v-model="newApplyMail" @blur="checkReceiptorMails" />
                  <span v-show="notarization.applyMail">{{notarization.applyMail}}</span>
                  <span class="errorTips" v-model="errorTips.newApplyMail">{{errorTips.newApplyMail}}</span>
                </p>
                <p v-if="result.realNameType == 2">
                  <label>申请人职务：</label>
                  <input type="text" placeholder="请输入职务" v-model="notarization.applyPost" @blur="checkapplyPost" />
                  <span class="errorTips" v-model="errorTips.applyPost">{{errorTips.applyPost}}</span>
                </p> 
                <p v-if="result.realNameType == 1">
                  <label>申请人地址：</label>
                  <input type="text" placeholder="请输入地址" v-model="notarization.applyAddress" @blur="checkApplyAddress" />
                  <span class="errorTips" v-model="errorTips.applyAddress">{{errorTips.applyAddress}}</span>
                </p>
            </div>
          </div>
          <div class="pro-con-details" style="margin-top: 30px;">
            <div class="details-title">公证书</div>
            <div class="apply-contact-infos">
               <!-- <p>
                <label>公证书用途：</label>
                <el-select v-model="notarization.notaryCertificateUse" popper-class="el-select-box" size="medium" :popper-append-to-body="false" placeholder="请选择">
                     <el-option 
                      :label="'诉讼或仲裁（仅限于民事诉讼或仲裁）'"
                      :value="'1'">
                      </el-option>
                      <el-option 
                      :label="'其他'"
                      :value="'0'">
                      </el-option>
                  </el-select>
               </p> -->
              <p>
                <label>公证书份数：</label>
                <input type="text" placeholder="输入1-100之间的整数" v-model="notarization.paperAmount" @blur="checkPageAmount" v-if="compeletHiden" />
                <span v-if="!compeletHiden">{{notarizationInfo.paperAmount}}</span>
                <span class="errorTips" v-model="errorTips.paperAmount">{{errorTips.paperAmount}}</span>
              </p>
               <p>
                <label>公证书送达方式：</label>
                <el-select v-if="notarizationInfo.recipientType==1"  v-model="notarization.notaryCertificateType" popper-class="el-select-box" size="medium" :popper-append-to-body="false" placeholder="请选择">
                     <el-option 
                      :label="'电子公证书和纸质公证书本人领取'"
                      :value="'3'">
                      </el-option>
                      <el-option 
                      :label="'电子公证书'"
                      :value="'1'">
                      </el-option>
                  </el-select>
                  <el-select  v-else  v-model="notarization.notaryCertificateType" popper-class="el-select-box" size="medium" :popper-append-to-body="false" placeholder="请选择">
                     <el-option 
                      :label="'电子公证书和纸质公证书他人领取'"
                      :value="'3'">
                      </el-option>
                      <el-option 
                      :label="'电子公证书'"
                      :value="'1'">
                      </el-option>
                  </el-select>
               </p>
               
              <!-- <p v-else>
                <label>户籍所在地：</label>
                <input type="text" v-model="notarization.userDomicile" @blur="checkUserDomicile" v-if="compeletHiden" />
                <span v-if="!compeletHiden" class="ell" v-bind:title="notarizationInfo.userDomicile">{{notarizationInfo.userDomicile}}</span>
                <span class="errorTips" v-model="errorTips.userDomicile">{{errorTips.userDomicile}}</span>
              </p> -->
              <!-- <p v-if="result.realNameType != 2">
                <label>现居住地址：</label>
                <input type="text" v-model="notarization.userAddress" @blur="checkUserAddress" v-if="compeletHiden" />
                <span v-if="!compeletHiden" style="
    margin-top: 6px;" class="ell" v-bind:title="notarizationInfo.userAddress">{{notarizationInfo.userAddress}}</span>
                <span class="errorTips" v-model="errorTips.userAddress">{{errorTips.userAddress}}</span>
              </p> -->
                <template v-if="notarization.notaryCertificateType=='3'">
                  <!-- 本人领取 企业用户 start -->
                  <!-- <template v-if="notarizationInfo.recipientType==1">
                    <p  style="margin-top: 8px;">
                      <label>领取人姓名：</label>
                      <span style="display: inline-block;" v-if='notarizationInfo.proxyName '>{{notarizationInfo.proxyName }}</span>
                      <span style="display: inline-block;" v-else>{{notarizationInfo.applier}}</span>
                    </p>
                    <p >
                      <label>领取人身份证号：</label>
                      <span v-if='notarizationInfo.proxyCard'>{{notarizationInfo.proxyCard}}</span>
                      <span v-else>{{notarizationInfo.userIdCard}}</span>
                    </p>
                      <p >
                      <label>领取人手机号：</label>
                      <input type="text" placeholder="输入领取人手机号" v-model="notarization.proxyMobile" @blur="checkReceiptorMobile" v-if="compeletHiden" />
                      <span v-if="!compeletHiden">{{notarizationInfo.proxyMobile}}</span>
                      <span class="errorTips" v-model="errorTips.proxyMobile">{{errorTips.proxyMobile}}</span>
                    </p>
                    <p >
                      <label>领取人邮箱：</label>
                      <input type="text" placeholder="输入领取人邮箱（非必填）" v-model="notarization.proxyMail" @blur="checkReceiptorMail" v-if="compeletHiden" />
                      <span v-if="!compeletHiden">{{notarizationInfo.proxyMail}}</span>
                      <span class="errorTips" v-model="errorTips.proxyMail">{{errorTips.proxyMail}}</span>
                    </p>
                  </template> -->
                  <!-- 本人领取 end -->

                  <!-- 他人领取 企业和个人 start !notarizationInfo.isSelf &&-->
                  <template v-if=" notarizationInfo.recipientType==2">
                    <p >
                      <label>领取人姓名：</label>
                      <input type="text" placeholder="输入领取人姓名" v-model="notarization.proxyName" @blur="checkReceiptor" v-if="compeletHiden" />
                      <span v-if="!compeletHiden">{{notarizationInfo.proxyName}}</span>
                      <span class="errorTips" v-model="errorTips.proxyName">{{errorTips.proxyName}}</span>
                    </p>
                    <p>
                      <label>领取人身份证号：</label>
                      <input type="text" placeholder="输入领取人身份证号" v-model="notarization.proxyCard" @blur="checkReceiptorIdCard" v-if="compeletHiden" />
                      <span v-if="!compeletHiden">{{notarizationInfo.proxyCard}}</span>
                      <span class="errorTips" v-model="errorTips.proxyCard">{{errorTips.proxyCard}}</span>
                    </p>
                    <p>
                      <label>领取人手机号：</label>
                      <input type="text" placeholder="输入领取人手机号" v-model="notarization.proxyMobile" @blur="checkReceiptorMobile" v-if="compeletHiden" />
                      <span v-if="!compeletHiden">{{notarizationInfo.proxyMobile}}</span>
                      <span class="errorTips" v-model="errorTips.proxyMobile">{{errorTips.proxyMobile}}</span>
                    </p>
                    <p>
                      <label>领取人邮箱：</label>
                      <input type="text" placeholder="输入领取人邮箱" v-model="notarization.proxyMail" @blur="checkReceiptorMail" v-if="compeletHiden" />
                      <span v-if="!compeletHiden">{{notarizationInfo.proxyMail}}</span>
                      <span class="errorTips" v-model="errorTips.proxyMail">{{errorTips.proxyMail}}</span>
                    </p>
                  </template>
                  <!-- 他人领取 end-->
               </template>
            </div>
          </div>
          <div class="submit-box" style="min-height: 30px;">
            <button @click="submitInfo" v-if="compeletHiden">提交信息</button>
          </div>
        </div>
        <!-- 签署文件 -->
        <div class="pro-con-detail-sign" v-if="stepControl.step2">
          <SignFile @signSubmit="signSubmit" :notaryApplyId="notaryApplyId" :user="user"></SignFile>
        </div>  
        <!-- 信息审核 -->
        <div class="progress-con2" v-if="stepControl.step3Ing">
          <div class="pro-con-details">
            <div class="details-title">审核状态</div>
            <div class="check-status clearfix">
              <img src="@assets/images/judicial/tips.png">
             <p class="tips-info">您的申请信息已提交公证处审核，预计1个工作日内会将审核结果通过短信发送到您的手机上，请您注意查收。在此期间如您有疑问可联系客服电话：
                <span>020-83183060</span>
              </p>
            </div>
          </div>
        </div>
        <!-- 审核通过 -->
        <div class="progress-con2" v-if="stepControl.step3Success">
          <div class="pro-con-details">
            <div class="details-title">审核状态</div>
            <div class="check-status clearfix">
              <img src="@assets/images/judicial/success.png">
              <p class="tips-info" style="margin-top:15px;">您的公证申请已通过审核！
                <span></span>
              </p>
            </div>
          </div>
        </div>
        <!-- 审核未通过 -->
        <div class="progress-con2" v-if="stepControl.step3Fail">
          <div class="pro-con-details">
            <div class="details-title">审核状态</div>
            <div class="check-status clearfix">
              <img src="@assets/images/judicial/fail.png">
              <p class="tips-info" style="word-wrap: break-word">您的申请信息已被拒绝，<br/> 公证处拒绝原因：
                <span>{{notarizationInfo.rejection}}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="submit-box" style="min-height: 30px;" v-if="stepControl.step3Fail">
          <button @click="reUpdate" v-if="stepControl.isRefill">重新提交</button>
        </div>
        <!-- 支付费用 -->
        <!-- <div class="progress-con3" v-if="stepControl.step4">
          <PayFees @signPayFeesSubmit="signPayFeesSubmit" :user="user" :payMoney="notarizationInfo.cost" :notaryApplyId="notaryApplyId" :notarizationInfo="notarizationInfo"></PayFees>
        </div> -->
        <!-- 等待制证 -->
        <div class="progress-con3" v-if="stepControl.step4Wait">
          <div class="pro-con-details">
            <div class="details-title">审核状态</div>
            <table class="table" style="font-size: 14px;">
              <tr class="tr-header" style="font-weight:100">
                <th>公证编号</th>
                <th>公证处</th>
                <th>申请人</th>
                <th>公证书领取人</th>
                <th>公证书份数</th>
                <th>文件大小</th>
              </tr>
              <tr class="tr">
                <td>{{notarizationInfo.code}}</td>
                <td>{{notarizationInfo.office}}</td>
                <td>{{notarizationInfo.applier}}</td>
                <td>{{notarizationInfo.proxyName}}</td>
                <td>{{notarizationInfo.paperAmount}}</td>
                <td>{{notarizationInfo.fileSize}}</td>
              </tr>
            </table>
            <div class="sum-money">已付款：
              <span>￥
                <i>{{notarizationInfo.cost}}</i>
              </span>
            </div>
          </div>
        </div>
        <!-- 等待制证 -->
        <div class="progress-con4" v-if="stepControl.step5Wait">
          <div class="pro-con-details">
            <div class="details-title">等待制证</div>
            <div class="wait-certificate">
              <div style="padding:0 30px;margin-top:20px;line-height:26px;">
                您已成功支付公证费用，请等待公证处制作公证书。公证处开始制证后我们会将取证时间通过短信发送到您的手机上，请您注意查收。在此期间如您有疑问可联系客服电话：
                <span>020-83183060</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 预约取证 -->
        <div class="progress-con4" v-if="stepControl.step5">
          <Forensics :notarizationInfo="notarizationInfo"></Forensics>
        </div>
      </div>
    </div>
    <Dialog :visible="showFace"
      :dialogTitle="'人脸识别认证'"
      @closeDialog="closeFaceModal"
      :width="'500px'">
       <div slot="dialog" >
     <!-- <action-modal v-if="$store.state.actionModal.showActionModal" @selectRes="selectRes"></action-modal> -->
        <div class="rlsbW">
          <p class="rlsb_title"><span></span>&nbsp;二维码5分钟内有效&nbsp;<span></span> </p> 
          <div class="erweima" v-show="codeStatus!=0 && !error_num">
            <vue-qr id="canvass" :text="erweimaUrl" :size="180"></vue-qr>
          </div>
          <div class="erweima_errro" v-show="error_erweima && codeStatus!=0">
            <p class="error_title">二维码失效</p>
            <span class="update_erweima" @click="updateEr">点击刷新</span>
          </div>
          <div class="erweima_errro" style="width: 270px;margin-left: -135px;" v-show="error_num">
            <p class="error_title">{{text}}</p>
          </div>
          <div class="erweima_success" v-show="(status==1||status==2) && codeStatus!=0">
            <img src="../../../../../assets/images/userHome/wxsmcg_icon.png"/>
            <p class="success_title">扫描成功</p>
            <p class="success_desc">请在手机端刷脸认证</p>
            <span class="success_update_erweima" @click="updateEr">点击刷新</span>
          </div>
          <div class="erweima_success" v-show="codeStatus==0">
            <img src="../../../../../assets/images/userHome/wxsmcg_iconS.png"/>
            <p class="success_title" style="margin-top:15px;">已完成人脸验证</p>
          </div>
          <p class="rlsb_desc" v-show="codeStatus!=0" :style="{'margin-top':codeStatus==0?'180px':'20px'}">
            请使用微信或其他软件扫描二维码，并依照提示完成人脸识别认证
          </p>
          <button class="success_face" type="button" v-show="codeStatus==0 && status==2"  @click="getFaceResult">已完成人脸验证</button>
             <!-- <button class="error_face" type="button">未完成人脸验证</button> -->
        </div>
       </div>
    </Dialog>

  </div>
</template>

<script scoped>
import commenConst from "@lib/const.js";
// import ActionModal from "../../../components/common/ActionModal";
// import FaceModal from "../../../components/common/FaceModal";
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
import CryptoJSFn from '@lib/secret';
import SignFile from "./fqExecution/SignFile.vue";
// import PayFees from "./PayFees.vue";
import Forensics from "./fqExecution/Forensics.vue";
import VueQr from "vue-qr";
export default {
  name: "",
  components: { VueQr,SignFile,Forensics,Dialog},
  data() {
    return {
      user: {},
      isSelf: -1,
      checkStatus: -1,
      notaryApplyId: -1,
      notarizationInfo: {},
      compeletHiden: true,
      notarization: {
        //固定信息
        uid: -1,
        notaryApplyId: -1,
        userIdCard: "",
        //需要输入的信息
        paperAmount: "", //公证文份数
        userDomicile: "", //户籍所在地
        userAddress: "", //现居住地
        proxyName: "", //领取人姓名
        proxyCard: "", //领取人身份证号
        proxyMobile: "", //领取人手机号
        proxyMail: "", //领取人邮箱
        applyMobile:"",//申请人手机号
        applyMail:"",//申请人邮箱
        notaryCertificateUse:'1',//用途
        notaryCertificateType:'3',//送达方式
        applyAddress:"",//申请人地址
        applyPost:"",//申请人职务
        //法人
        legalPerson:"",
        legalPersonIdCardNumber:"",
        legalPersonTel:"",
        legalPersonPost:""
      },
      errorTips: {
        paperAmount: "",
        userDomicile: "",
        newApplyMobile:"",
        newApplyMail:"",
        userAddress: "",
        applyAddress:"",//申请人地址
        applyPost:"",//申请人职务
        proxyName: "", //领取人姓名
        proxyCard: "", //领取人身份证号
        proxyMobile: "", //领取人手机号
        proxyMail: "", //领取人邮箱
        //法人
        legalPerson:"",
        legalPersonIdCardNumber:"",
        legalPersonTel:"",
        legalPersonPost:""
      },
      stepControl: {
        step1: false,
        step2:false,
        step3Ing: false,
        step3Success: false,
        step3Fail: false,
        isRefill: true,
        step3: false,
        step4Wait: false,
        step4: false,
        step5: false,
        step5Wait:false,
        step1Tit: true,
        step2Tit: false,
        step3Tit: false,
        step4Tit: false,
        step5Tit: false
      },
       erweimaUrl:"http://localhost:3200/personal/serviceHome/writeProcedure?dasdasdd=dasdasdasdas",
      //二维码扫描成功
      success_erweima:false,
      //二维码失效
      error_erweima:false,
      //人脸识别弹框
      showFace:false,
      orderNo:"",//订单号
      status:0,//二维码状态
      codeStatus:null,//认证状态
      error_num:false,
      text:"",
      setTimer:null,
      signSubmitInfo:{},//签署文件参数
      faceType:1,//1-提交申请人脸 ,2-签署文件人脸
      newApplyMobile:"",
      newApplyMail:"",
      result:{}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.notaryApplyId = this.$router.history.current.query.notaryApplyId;
      this.user = JSON.parse(sessionStorage.getItem("userInfo"));
      //补充要提交的信息
      this.notarization.uid = this.user.currentUserId;
      this.notarization.notaryApplyId = this.notaryApplyId;
      //初次数据请求
      this.infoRequest();
    },
    infoRequest() {
      this.$store.commit("showLoading", true);
      let params={
            notaryApplyId: this.notaryApplyId
          }
         BaseApi.createRpcToken("/notaryApply/getNotarizationInfo", params, "post")
        .then(response => {
          this.$store.commit("showLoading", false);
          if (response.code == 200) {
            //status  状态（0审核拒绝1等待提交2签署文件 3等待审核4等待付费4等待制证5已公证）
            let infoObj = response.datas;
            this.checkStatus = infoObj.status;
            //领取人类型
            if (infoObj.recipientType == 1) {
              infoObj.receiptorTypeName = "本人领取";
              infoObj.recipientType=1
              //本人领取的话更新不需要填写的信息
              this.notarization.proxyName = infoObj.proxyName;
              this.notarization.proxyCard = infoObj.proxyCard;
              this.isSelf = 1; //本人
              infoObj.isSelf = true;
            } else {
              this.isSelf = 0; //他人
              infoObj.receiptorTypeName = "他人领取";
              infoObj.isSelf = false;
              infoObj.recipientType=2
            }
            this.notarization.recipientType=infoObj.recipientType;
            this.notarization.userIdCard = infoObj.userIdCard;
            //等待提交---step1
            if (infoObj.status == 1) {
              //进度条控制
              this.stepControl.step1Tit = true;
              //展示内容控制
              this.stepControl.step1 = true;

              this.notarizationInfo = infoObj;
            }
            //审核拒绝---step3
            if (infoObj.status == 0) {
              //进度条控制
              this.stepControl.step1Tit = true;
              this.stepControl.step2Tit = true;
              //展示内容控制
              this.stepControl.step3Fail = true;
              this.stepControl.isRefill = infoObj.payType == 2 ? false : true;
              //改变第一步
              this.compeletHiden = false;
              this.notarizationInfo = infoObj;
            }
            //等待审核---step3
            if (infoObj.status == 2) {
              //进度条控制
              this.stepControl.step1Tit = true;
              this.stepControl.step2Tit = true;
              this.stepControl.step3Tit = true;
              //展示内容控制
              // this.stepControl.step3Ing = true;
               this.stepControl.step3Ing = true;
              //改变第一步
              this.compeletHiden = false;
              this.notarizationInfo = infoObj;
            }
            //等待付费---step4
            if (infoObj.status == 3) {
              //进度条控制
              this.stepControl.step1Tit = true;
              this.stepControl.step2Tit = true;
              this.stepControl.step3Tit = true;
              this.stepControl.step4Tit = true;
              //展示内容控制
              this.stepControl.step4 = true;
              //改变第一步
              this.compeletHiden = false;
              infoObj.cost = infoObj.cost / 100;
              this.notarizationInfo = infoObj;
            }
            //等待制证---step5
            if (infoObj.status == 4) {
              //进度条控制
              this.stepControl.step1Tit = true;
              this.stepControl.step2Tit = true;
              this.stepControl.step3Tit = true;
              this.stepControl.step4Tit = true;
              //展示内容控制
              this.stepControl.step5Wait = true;
              //改变第一步
              this.compeletHiden = false;
              infoObj.cost = infoObj.cost / 100;
              this.notarizationInfo = infoObj;
            }
            //已公证---step5
            if (infoObj.status == 5) {
              //进度条控制
              this.stepControl.step1Tit = true;
              this.stepControl.step2Tit = true;
              this.stepControl.step3Tit = true;
              this.stepControl.step4Tit = true;
              this.stepControl.step5Tit = true;
              //展示内容控制
              this.stepControl.step5 = true;
              //改变第一步
              this.compeletHiden = false;
              infoObj.cost = infoObj.cost / 100;
              infoObj.receiveDateFormate = this.$moment(
                infoObj.receiveDate
              ).format("YYYY-MM-DD");
              this.notarizationInfo = infoObj;
            }
            // 6-签署文件
            if (infoObj.status == 6) {
              //进度条控制
              this.stepControl.step1Tit = true;
              this.stepControl.step2Tit = true;
              //展示内容控制
              this.stepControl.step2 = true;
              //改变第一步
              this.compeletHiden = false;
              infoObj.cost = infoObj.cost / 100;
              infoObj.receiveDateFormate = this.$moment(
                infoObj.receiveDate
              ).format("YYYY-MM-DD");
              this.notarizationInfo = infoObj;
            }
            
               BaseApi.createRpcToken("/user/v2/getUserInfo", {
                  // uid: this.user.currentUserId
                }, "post")
              .then(response => {
                    let userArr=[...[response.datas.person],...response.datas.enterpriseList];
                    let curInfo=userArr.filter(item=>item.userId==response.datas.currentUserId);
                    this.result=curInfo[0]
                let data = response.datas.person;
                this.notarization.proxyName=data.realName;
                this.notarization.proxyCard=data.idcardNumber;
                this.notarization.proxyMobile=data.mobile;
                this.notarization.proxyMail=data.mail;
                this.notarization.applyMobile=data.mobile;
                 this.notarization.applyMail=data.mail;
                this.newApplyMobile=this.notarization.applyMobile;
                this.newApplyMail=this.notarization.applyMail;
                // if( this.result.realNameType==2){
                  this.notarizationInfo.realname=data.realName;
                  this.notarizationInfo.idcardNumber=data.idcardNumber;
                // }
                 //法人
                 console.log(infoObj.recipientType)
                 if (infoObj.recipientType != 1) {
                    this.clearNotarInfo();
                  }
                  // this.$store.commit('showLoading', true);
              BaseApi.createRpcToken("/user/v2/getUserAuthInfo", {enterpriseId:this.result.id,type:2})
                .then(
                  data => {
                    if(data.datas){
                      this.notarization.legalPersonPost=data.datas.legalPersonPost;
                      this.notarization.legalPerson=data.datas.legalPersonName;
                      this.notarization.legalPersonIdCardNumber=data.datas.legalPersonIdcardNumber;
                      this.notarization.legalPersonTel=data.datas.legalPersonMoblie;
                      if(infoObj.recipientType == 1){
                        this.notarization.proxyCard = data.datas.legalPersonIdcardNumber;
                      }
                    }
                  })
                  .catch(function(e) {
                    errorLog(e);
                  });
              })
             this.notarization.userAddress=this.notarizationInfo.userAddress;
              
            
          } else {
            this.$store.dispatch("showMsgModal", {
              autoClose: true,
              info: response.message
            });
          }
        },data=>{
           this.$store.commit("showLoading", false);
        });
    },
    //他人领取清空数据
    clearNotarInfo(){
        this.notarization.proxyName="";
        this.notarization.proxyCard="";
        this.notarization.proxyMobile="";
        this.notarization.proxyMail="";
    },
    //转换文件大小
     filterType(val){
      if(val === 0)return "0 B";
      var k= 1024;
      var sizes=['B',"KB","MB","GB","TB","PB","EB","ZB","YB"],
      i= Math.floor(Math.log(val) / Math.log(k));
      return (val / Math.pow(k,i)).toPrecision(3) + " " + sizes[i];
    },
    reUpdate() {
      this.compeletHiden = true;
      this.goStep1();
    },
    //填写信息
    goStep1() {
      this.initStep();
      this.stepControl.step1 = true;
    },
    // 签署文件
    goStep2() {
      this.initStep();
      this.stepControl.step2 = true;
    },
    //信息审核
    goStep3() {
      this.initStep();
      if (this.checkStatus == 0) {
        this.stepControl.step3Fail = true;
        this.stepControl.isRefill =
          this.notarizationInfo.payType == 2 ? false : true;
      } else if (this.checkStatus == 2) {
        this.stepControl.step3Ing = true;
      } else if (this.checkStatus == 3) {
        this.stepControl.step3Success = true;
      } else {
        this.stepControl.step3Success = true;
      }
    },
    //支付费用
    goStep4() {
     this.initStep();
      //内容
      if (this.checkStatus == 4 || this.checkStatus == 5) {
        if (this.notarizationInfo.payType != 2) {
          //普通
          this.stepControl.step4Wait = true;
        } else {
          //优惠
          if (this.checkStatus == 4) {
            this.stepControl.step5Wait = true;
          } else {
            this.stepControl.step4 = true;
          }
        }
      } else if (this.checkStatus == 3) {
        this.stepControl.step3 = true;
      }
    },
    //预约取证
    goStep5() {
      this.initStep();
      if (this.checkStatus == 4) {
        this.stepControl.step5Wait = true;
      } else if (this.checkStatus == 5) {
        this.stepControl.step5 = true;
      }
    },
    initStep() {
      for (let i in this.stepControl) {
        this.stepControl[i] = false;
      }
      //status  状态（0审核拒绝1等待提交2等待审核3等待付费4等待制证5已公证）
      if (this.checkStatus == 0) {
        this.stepControl.step1Tit = true;
        this.stepControl.step2Tit = true;
        this.stepControl.step3Tit = true;
      } else if (this.checkStatus == 1) {
        this.stepControl.step1Tit = true;
      } else if (this.checkStatus == 2) {
        this.stepControl.step1Tit = true;
        this.stepControl.step2Tit = true;
        this.stepControl.step3Tit = true;
      } else if (this.checkStatus == 3) {
        this.stepControl.step1Tit = true;
        this.stepControl.step2Tit = true;
        this.stepControl.step3Tit = true;
        this.stepControl.step4Tit = true;
      } else if (this.checkStatus == 4) {
        this.stepControl.step1Tit = true;
        this.stepControl.step2Tit = true;
        this.stepControl.step3Tit = true;
        this.stepControl.step4Tit = true;
        this.stepControl.step5Tit = true;
      }else if(this.checkStatus == 6){//签署文件
         this.stepControl.step1Tit = true;
         this.stepControl.step2Tit = true;
      }else{
        this.stepControl.step1Tit = true;
        this.stepControl.step2Tit = true;
        this.stepControl.step3Tit = true;
      }
    },
    checkPageAmount() {
      let obj = this.notarization.paperAmount;
      if (
        this.notarization.paperAmount > 0 &&
        this.notarization.paperAmount < 101
      ) {
        if (!isNaN(obj) && obj % 1 === 0 && obj.indexOf(".") == -1) {
          this.errorTips.paperAmount = "";
          return true;
        } else {
          this.errorTips.paperAmount = "请输入有效公证书份数(1-100之间的整数)";
          return false;
        }
      } else {
        this.errorTips.paperAmount = "请输入有效公证书份数(1-100之间的整数)";
        return false;
      }
    },
    // checkUserDomicile() {
    //   if (
    //     this.notarization.userDomicile.length > 9 &&
    //     this.notarization.userDomicile.length < 51
    //   ) {
    //     this.errorTips.userDomicile = "";
    //     return true;
    //   } else {
    //     this.errorTips.userDomicile = "地址长度在10到50个字符之间";
    //     return false;
    //   }
    // },
    checkUserAddress() {
      if (
        this.notarization.userAddress.length > 9 &&
        this.notarization.userAddress.length < 51
      ) {
        this.errorTips.userAddress = "";
        return true;
      } else {
        this.errorTips.userAddress = "地址长度在10到50个字符之间";
        return false;
      }
    },
    checkApplyAddress(){
      if (
        this.notarization.applyAddress.length > 9 &&
        this.notarization.applyAddress.length < 51
      ) {
        this.errorTips.applyAddress = "";
        return true;
      } else {
        this.errorTips.applyAddress = "地址长度在10到50个字符之间";
        return false;
      }
    },
    checkapplyPost(){
      if (this.notarization.applyPost!="") {
        this.errorTips.applyPost = "";
        return true;
      } else {
        this.errorTips.applyPost = "请输入职务";
        return false;
      }
    },
    checkReceiptor() {
      let realnameReg = commenConst.INPUTRULES.realname;
      if (realnameReg.test(this.notarization.proxyName)) {
        this.errorTips.proxyName = "";
        return true;
      } else if (this.notarization.proxyName.length == 0) {
        this.errorTips.proxyName = "此项不能为空";
        return false;
      } else {
        this.errorTips.proxyName = "您输入的字符有误，请检验";
        return false;
      }
    },
    checkReceiptorIdCard() {
      let idReg = commenConst.INPUTRULES.id;
      if (idReg.test(this.notarization.proxyCard)) {
        this.errorTips.proxyCard = "";
        return true;
      } else if (this.notarization.proxyCard.length == 0) {
        this.errorTips.proxyCard = "此项不能为空";
        return false;
      } else {
        this.errorTips.proxyCard = "您输入的字符有误，请检验";
        return false;
      }
    },
    checkReceiptorMail() {
      let emailReg = commenConst.INPUTRULES.email;
      if (emailReg.test(this.notarization.proxyMail)) {
        this.errorTips.proxyMail = "";
        return true;
      } else {
        this.errorTips.proxyMail = "请输入正确的E-Mail地址";
        return false;
      }
    },
    checkReceiptorMobile() {
      let mobileReg = commenConst.INPUTRULES.mobile;
      if (mobileReg.test(this.notarization.proxyMobile)) {
        this.errorTips.proxyMobile = "";
        return true;
      } else {
        this.errorTips.proxyMobile = "请输入正确的手机号";
        return false;
      }
    },
    checklegalPersonTel() {
      let mobileReg = commenConst.INPUTRULES.mobile;
      if (mobileReg.test(this.notarization.legalPersonTel)) {
        this.errorTips.legalPersonTel = "";
        return true;
      } else {
        this.errorTips.legalPersonTel = "请输入正确的手机号";
        return false;
      }
    },
    checklegalPersonPost() {
      if (this.notarization.legalPersonPost !="") {
        this.errorTips.legalPersonPost = "";
        return true;
      } else {
        this.errorTips.legalPersonPost = "请输入职务";
        return false;
      }
    },
    checklegalPersonIdCardNumber() {
      let idReg = commenConst.INPUTRULES.id;
      if (idReg.test(this.notarization.legalPersonIdCardNumber)) {
        this.errorTips.legalPersonIdCardNumber = "";
        return true;
      } else if (this.notarization.legalPersonIdCardNumber.length == 0) {
        this.errorTips.legalPersonIdCardNumber = "此项不能为空";
        return false;
      } else {
        this.errorTips.legalPersonIdCardNumber = "您输入的字符有误，请检验";
        return false;
      }
    },
    checklegalPerson() {
      let mobileReg = commenConst.INPUTRULES.mobile;
      if (this.notarization.legalPerson!="") {
        this.errorTips.legalPerson = "";
        return true;
      } else {
        this.errorTips.legalPerson = "请输入法人姓名";
        return false;
      }
    },
    checkReceiptorMobiles() {
      let mobileReg = commenConst.INPUTRULES.mobile;
      if (mobileReg.test(this.newApplyMobile)) {
        this.errorTips.newApplyMobile = "";
        return true;
      } else {
        this.errorTips.newApplyMobile = "请输入正确的手机号";
        return false;
      }
    },
    checkReceiptorMails() {
      let mobileReg = commenConst.INPUTRULES.email;
      if (mobileReg.test(this.newApplyMail)) {
        this.errorTips.newApplyMail = "";
        return true;
      } else {
        this.errorTips.newApplyMail = "请输入正确的E-Mail地址";
        return false;
      }
    },
    //关闭人脸弹框
    closeFaceModal(){
      this.showFace=false;
      clearTimeout(this.setTimer)
    },
     getTimeFun(){
        let d=new Date();
        let ye = d.getFullYear();
        let mo = (d.getMonth()+1).toString().padStart(2,'0');
        let da = d.getDate().toString().padStart(2,'0');
        let time = ye+'/'+mo+'/'+da;
        return time;
      },
     //获取人脸识别二维码
    getFaceAuthOrderNo(){
      let times=this.getTimeFun();
      let name,idcardNumber;
      if(this.result.realNameType == 1){//个人 
        name=CryptoJSFn.Encrypt(`${times}${this.notarizationInfo.applier}`);//姓名加密
        idcardNumber=CryptoJSFn.Encrypt(`${times}${this.notarizationInfo.userIdCard}`);//身份证号加密  
      }else{//企业
        name=CryptoJSFn.Encrypt(`${times}${this.notarizationInfo.realname}`);//姓名加密
        idcardNumber=CryptoJSFn.Encrypt(`${times}${this.notarizationInfo.idcardNumber}`);//身份证号加密  
      }
      let timer=null;
      // let htid=this.$route.query.id;
      // //第三步进行人脸识别验证
      // let queryStrUrl={
      //   liveType: 2,
      //   contractId: htid,
      // };
      //获取二维码地址
      clearInterval(timer) 
        BaseApi.createRpcToken("/user/getFaceAuthOrderNo", {
                  userId: this.user.person.userId,
                  liveType:4
                }, "post")
          .then(data=>{
        if(data.code==200){
          this.showFace=true;
          var endTime = new Date().getTime()+5*60*1000;
          this.orderNo=data.datas.orderNo;//data.datas.url
          if(this.orderNo!=-1){
            this.setTimerEr();
            let userIDd=localStorage.getItem('userId')?localStorage.getItem('userId'):this.user.currentUserId, 
               tokenId=localStorage.getItem('token');
            //  faceSignyz  window.location.origin+
            this.erweimaUrl=window.location.origin+"/m/sign-perStartFace?orderNo="+this.orderNo+"&uid="+this.user.currentUserId+"&typesP=4&notaryApplyStatus="+this.notarizationInfo.status+"&token="+tokenId+"&notaryApplyId="+this.notaryApplyId;
              timer=setInterval(()=>{
                var start =  new Date().getTime();
                if(start > endTime){
                  this.error_erweima=true;
                  this.status=0;
                  clearInterval(timer);
                }else{
                  if(this.status==1||this.status==2){
                    clearInterval(timer) 
                    this.error_erweima=false;
                  }else{
                    this.error_erweima=false;
                  }
                }
              },1000)
            if(this.status==1||this.status==2){
              clearInterval(timer) 
              this.error_erweima=false;
            }
          }else{
            this.text="人脸识别服务异常，请联系管理员！"
            this.error_num=true;
            this.status=0;
            this.error_erweima=false;
          }
        }else{
          // //console.log('erweimadizhi error',data)
          this.error_erweima=true;
          this.status=0;
        }
      })
    },
    //实时获取二维码状态
    setTimerEr() {
      let orderNos=this.orderNo;
      let obj={orderNo:orderNos};
         BaseApi.createRpcToken("/user/getFaceAuthStatus", {
                 orderNo:orderNos
                }, "get").then(data=>{
        if(data.code==200){
          clearTimeout(this.setTimer)
          this.status=data.datas.status;
          this.codeStatus=data.datas.authStauts;
          let self=this;
          if (self && !self._isDestroyed) {
            this.setTimer = setTimeout(() => {
              this.setTimerEr()
            }, 1000)  
          }
          if(obj.orderNo!=this.orderNo){
            clearTimeout(this.setTimer)
          }
          //二维码失效
          else if(this.error_erweima){
            clearTimeout(this.setTimer)
          }
          //成功
          else if(data.datas.authStauts==0){
            clearTimeout(this.setTimer)
          }
          //失败0-成功，-1未完成，其余都是失败。
          else if(data.datas.authStauts!=0 && data.datas.authStauts!=-1){
            clearTimeout(this.setTimer)
          }
        }
      else {
        clearTimeout(this.setTimer) //清理定时任务
      }
      })
    },      
    //刷新二维码
    updateEr(){
      if(this.codeStatus==0){
        return;
      }else{
        this.error_erweima=false;
        this.getFaceAuthOrderNo();
      }
    },
    //获取实名认证结果
    getFaceResult(){
      let timer=null;
      let orderNos=this.orderNo;
      clearTimeout(timer);
      if (this.codeStatus==0) {
         BaseApi.createRpcToken("/user/getFaceAuthStatus", {
                 orderNo:orderNos
                }, "get").then(data=>{
          let datas=data.datas
          if (datas.authStauts==0) {
            this.codeStatus=datas.authStauts;
            if(this.faceType==1){
              //提交申请信息
              this.sumitNotrayInfo();
            }else{
              //签署文件
              this.signSubmitFn();
            }
            this.closeFaceModal();
          } else {
            this.codeStatus=datas.authStauts;
          }
        });
      } else {
        this.codeStatus=-1;
        this.openTest=true;
        this.text="人脸识别认证失败，请重试";
        timer=setTimeout(()=>{
          this.codeStatus=-2;
          this.openTest=false;
        },5000)
      }
    },
    //签署文件人脸
    signSubmit(datas){
      this.signSubmitInfo=datas;
       this.getFaceAuthOrderNo();
       this.faceType=2;
    },
    //签署文件
    signSubmitFn(){
          this.$store.commit("showLoadingText", true);
         BaseApi.createRpcToken("/notaryApply/signNotarization", this.signSubmitInfo, "POST").then(response => {
          if (response.code == 200) {
            this.$store.commit("showLoadingText", false);
            this.initStep();
            this.infoRequest();
          } else {
            this.$store.commit("showLoadingText", false);
            this.$store.dispatch("showMsgModal", {
              autoClose: true,
              info: response.message
            });
          }
        });  
    },
    //支付费用提交
    signPayFeesSubmit(datas){
      this.selectRes(datas);
    },
    //申请信息提交
    submitInfo() {
      // if(this.notarization.applyMobile){}else{
      //   this.notarization.applyMobile=this.newApplyMobile;
      // } 
      // if(this.notarization.applyMail){}else{
      //    this.notarization.applyMail=this.newApplyMail;
      // }
      if(this.result.realNameType == 2 && this.notarization.notaryCertificateType=='3' && this.isSelf){ //本人

        var res = 
        this.checklegalPerson()&&//法人姓名
        this.checklegalPersonIdCardNumber()&&//法人证件号
        this.checklegalPersonTel()&&//法人手机号
        this.checklegalPersonPost()&&//法人职务
          this.checkapplyPost()&&//申请人职务
          //领取人邮箱
          // this.checkReceiptorMobile()&&//领取人手机号
          // this.checkUserAddress() &&  //申请人地址
          this.checkReceiptorMobiles()&& //申请人手机号
           this.checkPageAmount() && //公正数量
          this.checkReceiptorMails(); //申请人邮箱

      }else if(this.result.realNameType == 1 && this.notarizationInfo.isSelf && this.notarization.notaryCertificateType=='3'){
        var res =
        this.checkReceiptorMails()&& //申请人邮箱
        this.checkApplyAddress()&& //申请人地址
          // this.checkUserDomicile() && //户籍所在地
          // this.checkUserAddress() && //申请人地址
        this.checkReceiptorMobiles()&& //申请人手机号
        this.checkPageAmount() ; //公正数量
      }else if(this.notarization.notaryCertificateType!='3' && this.result.realNameType == 2){
         var res = this.checkPageAmount() && //公正数量
          // this.checkUserDomicile() && //户籍所在地
          // this.checkUserAddress()&& //申请人住地
           this.checkReceiptorMobiles()&& //申请人手机号
          this.checkReceiptorMails(); //申请人邮箱
          // this.checkReceiptorMail() && //领取人邮箱
          // this.checkReceiptorMobile(); //领取人手机号
      }else{
        var  res= this.checkPageAmount() && 
            // this.checkUserAddress()&& 
            this.checkReceiptorMobiles()&& 
            this.checkReceiptorMails(); 
      }
      if (!this.isSelf && this.notarization.notaryCertificateType=='3') {//他人领取
        res = res && this.checkReceiptor() && this.checkReceiptorIdCard() && this.checkReceiptorMobile() &&  this.checkReceiptorMail(); //领取人姓名 身份证号
      }
      if (res) {
        this.faceType=1;
        //显示人脸识别弹框
        this.getFaceAuthOrderNo();
      }else{
        this.showFace=false;
      }
    },
    sumitNotrayInfo(){
      this.$store.commit('showLoading', true);
      let realName= this.result.realNameType == 2 ?this.result.realName:this.notarizationInfo.realname
      let params ={...this.notarization,userRegisterName:realName,usertype:this.result.realNameType,applyMobile:this.newApplyMobile,//申请人手机号
        applyMail:this.newApplyMail};
        //console.log(params,"params")
        //本人领取自动赋值领取人信息
        if(this.notarizationInfo.isSelf ){
          if(!params.proxyMobile){
            params.proxyMobile=params.applyMobile;
          }
          if(!params.proxyMail){
            params.proxyMail=params.applyMail;
          }
        }
        BaseApi.createRpcToken("/notaryApply/improveNotaryApply",params, "POST")
          .then(response => {
            if (response.code == 200) {
               this.$store.commit('showLoading', false);
              this.initStep();
              this.infoRequest();
            } else {
              this.$store.dispatch("showMsgModal", {
                autoClose: true,
                info: response.data.message
              });
            }
          });
    },
    // goPay() {
    //   this.$store.commit("showActionModal", {
    //     showActionModal: true,
    //     info: "是否确认支付" + this.notarizationInfo.cost + "元公证费用?"
    //   });
    // },
    //支付
    selectRes(dataInfo) {
      if (dataInfo) {
        BaseApi.createRpcToken("/personal/v2/getBalance",{
                    uid:this.user.currentUserId,
                }, "POST").then(response=>{
            	if(response.data.code==200){
            		if(response.data.datas.list.balanceFen>=this.notarizationInfo.cost){
        //      //支付成功进行签署
                BaseApi.createRpcToken("/notaryApply/afterSignNotarization",dataInfo, "POST").then(response => {
                  if (response.data.code == 200) {
                    this.$axios
                      .request({
                        url: "/webapi/notaryApply/payNotaryCertificate",
                        method: "POST",
                        data: {
                          uid: this.user.currentUserId,
                          id: this.notaryApplyId,
                          price: this.notarizationInfo.cost
                        }
                      })
                      .then(response => {
                        this.$store.dispatch("showMsgModal", {
                          autoClose: true,
                          info: response.data.message
                        });
                        if (response.data.code == 200) {
                          this.goStep4();
                          this.infoRequest();
                        }
                      });
                  } else {
                    this.$store.dispatch("showMsgModal", {
                      autoClose: true,
                      info: response.data.message
                    });
                  }
                });  
       
        		}else{
        			this.$store.dispatch('showMsgModal', {
               		autoClose: true,
               		info: '余额不足，请去充值'
            		});
        		}
        	}else{
        		this.$store.dispatch('showMsgModal', {
               	autoClose: true,
               	info: response.data.message
             });
        	}
        });
      }
    },
    goDataList() {
      this.$router.push("/judicial/dataList");
    }
  }
};
</script>

<style scoped lang="scss">
@import "@assets/scss/base.scss";
.ell{
  width: 660px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
}
button {
  font-size: 14px !important;
}
.errorTips {
  color: $reminder-text;
  float: left;
  margin-left: 6px;
}
.notarization-progress {
  box-sizing: border-box;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
}
/*位置*/
.content-top {
  height: 52px;
  background: url('../../../../../assets/images/judicial/pos.png') no-repeat;
  font-size: 16px;
  background-size: 3px 16px;
  background-position: 0 24px;
  box-sizing: border-box;
  padding-left: 13px;
  padding-top: 21px;
}
.content-top span {
  cursor: pointer;
  color: $reminder-text;
}
/*主要区域*/
.content-main {
  border-top: 1px solid #dbdbdb;
  padding-top: 20px;
}
.progress-current {
  width: 691px;
  margin: 24px auto 14px;
}
.progress-current img {
  height: 34px;
}
.progress-current .progress-current-info {
  color: #989898;
  height: 50px;
  line-height: 50px;
}
.progress-current .progress-current-info li {
  float: left;
  width: 138px;
  text-align: center;
}
.progress-current-info li:nth-child(2){
  margin-left: 44px;
}
.progress-current-info li:nth-child(3){
  margin-left: 54px;
}
.progress-current-info li:nth-child(4){
  width: 100px;margin-left: 56px;
}
.progress-current .progress-current-info .progress-current-info-li{
  color: $reminder-text;
} 
.progress-con {
  width: 830px;
  margin: 0 auto;
}
/*步骤*/
.step-box {
  width: 691px;
  height: 34px;
  position: relative;
  background: url('../../../../../assets/images/judicial/fqpro12.png') no-repeat;
  background-size: 100% 96.5%;
}
.step-subbox {
  width: 145px;
  height: 34px;
  position: absolute;
  height: 100%;
}
.step-subbox img {
  position: relative;
  z-index: 2;
  margin: 0 auto;
  margin-left: 55px;
  height: 32px;
}
.step-step1 {
  left: 0%;
}
.step-step2 {
  left: 19.3%;
}
.step-step3 {
  left: 49.3%;
}
.step-step4 {
  left: 59.3%;
}
.step-step5 {
  left: 69.3%;
}
.step-box .step-line {
  width: 159px;
  height: 4px;
  background-color: $reminder-border;
  overflow: hidden;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 42%;
  /*top:40%;*/
}
.step-step3 .step-line{
  width: 185px;
}
.step-step2 .step-line{
  width: 211px;
}
.step-step5 .step-line{
  width: 211px;
}
// .step-step4 {
//   width: 149px;
// }
// .step-box .step-line {
//   width: 149px;
// }
/*common start*/
.pro-con-details {
  margin: 0 auto;
  border: 1px solid #e4e4e4;
  /*border-radius: 4px;*/
  background-color: #f9f9f9;
  padding: 0 15px;
  color: #464646;
  min-height: 179px;
}
.pro-con-detail-sign{
  margin: 0 auto;
  // border: 1px solid #e4e4e4;
  /*border-radius: 4px;*/
  // background-color: #f9f9f9;
  padding: 0px;
  color: #464646;
}
.details-title {
  height: 46px;
  padding-top: 15px;
  border-bottom: 1px solid #e4e4e4;
  background: url(../../../../../assets/images/judicial/arrow.png) no-repeat;
  background-position: 0 19px;
  padding-left: 21px;
}
/*common end*/
/*----------------申请信息---------------*/
.apply-contact-infos {
  /*padding-left: 22px;*/
  margin-bottom: 15px;
  /deep/.el-select{
    width: 321px;
    .el-input__inner{
      height: 33px;
    }
  }
}
.apply-contact-infos > p {
      height: 30px;
    line-height: 30px;
    margin: 6px 0;
    display: flex;
    align-items: center;
}
.apply-contact-infos > p > label {
  display: inline-block;
  /*text-align:justify;
	text-align-last: justify;*/
  text-align: right;
  width: 136px;
  margin-right: 15px;
  // float: left;
}
.apply-contact-infos > p > input {
  height: 32px;
  width: 310px;
  border: 1px solid #e4e4e4;
  // float: left;
  padding-left: 8px;
}
.submit-box {
  text-align: center;
}
.submit-box button {
  margin: 23px auto 29px;
  background: #f5f5f5;
  width: 240px;
  height: 44px;
  line-height: 44px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  color: #464646;
  font-size: 14px;
}
.submit-box button:hover {
  background-color: $reminder-border;
  color: #fff;
  border: 1px solid $reminder-border;
}
/*----------------信息审核---------------*/
.check-status {
  width: 742px;
  margin: 30px auto;
  line-height: 1.75;
}
.check-status img {
  margin-top: 10px;
  float: left;
  width: 32px;
  height: 32px;
}
.check-status p.tips-info {
  width: 674px;
  float: right;
}
.check-status p.tips-info span {
  //color: #0066cc;
}
/*----------------支付费用---------------*/
.table {
  margin-top: 40px;
  margin-bottom: 26px;
}
.tr-header th {
  font-weight: 100;
}
.sum-money {
  text-align: right;
  height: 24px;
  line-height: 24px;
  margin-bottom: 27px;
}
.sum-money span {
  color: $reminder-text;
  font-size: 20px;
}
.sum-money span i {
  font-style: normal;
}
.pay-submit {
  text-align: center;
}
.pay-submit button {
  margin: 23px auto 29px;
  background: #f5f5f5;
  width: 172px;
  height: 44px;
  line-height: 44px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  color: #464646;
}
.pay-submit button:hover {
  background-color: $reminder-border;
  color: #fff;
  border: 1px solid $reminder-border;
}
/*----------------预约取证---------------*/
.wait-certificate {
  margin-bottom: 40px;
}
.get-title {
  padding-left: 26px;
  height: 60px;
  line-height: 60px;
}
.get-item {
  padding-left: 127px;
  line-height: 1.75;
}
.get-item label {
  display: inline-block;
  text-align-last: justify;
  width: 96px;
}
.get-tips {
  padding-left: 127px;
  color: #ffa800;
}
.inpWidth {
  width: 311px;
  height: 32px;
  border: solid 1px #bdbdbd;
  border-radius: 3px;
  background-color: #fff;
  padding-left: 10px;
  font-size: 14px;
}
.success_face{
  width:118px;
  height:32px;
  background:$reminder-border;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
  margin: 0 auto;
  display: block;
  cursor: pointer;
  margin-top:210px;
}
.rlsbW{
  width: 100%;
  height: 320px;
  position: relative;
  .erweima_errro{
    width: 180px;
    height: 180px;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 43px;
    left: 50%;
    margin-left:-90px;
    z-index: 99;
    text-align: center;
    padding-top: 60px;
    box-sizing: border-box;
    .error_title{
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:600;
      color:rgba(50,50,50,1);
      margin-bottom: 12px;
    }
    .update_erweima{
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:#000;
      cursor: pointer;
    }
  }
  .erweima_success{
     width:180px;
    height:180px;
    background:rgba(255,255,255,0.78);
    position: absolute;
    top: 38px;
    left: 50%;
    margin-left:-90px;
    z-index: 99;
    text-align: center;
    padding-top: 35px;
    box-sizing: border-box;
    .success_desc{
      margin-bottom: 10px;
      margin-top: 3px;
      font-size: 13px;
    }
    .success_title{
       font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:600;
      color:rgba(50,50,50,1);
    }
     .success_update_erweima{
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(77,175,247,1);
      cursor: pointer;
    }
    img{
      opacity: 1;
    }
  }
  .rlsb_title{
    color: #1890FF;
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
      display: inline-block;
      width: 8px;
      height: 1px;
      background: #1890FF;
      border:0;
    }
  }
  #canvass{
    width: 180px;
    margin: 0 auto;
    height: 180px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .rlsb_desc{
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    // margin-top: 20px;
  }
}
</style>
